/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

module.exports = {
  //设置面包屑导航
  SET_BREAD_CRUMB(state, breadCrumbArr) {
    state.breadCrumb = breadCrumbArr;
  },

  //设置alert的message
  SET_ALERT_MESSAGE(state, text) {
    state.alertInfo = text;
  },

  //新增按钮
  ADD_PAGE_BTN(state, comp) {
  	state.btnArr.push(comp);
  }
}



// WEBPACK FOOTER //
// ./src/common/vuex/mutation/common.js